import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  input,
} from '@angular/core';
import { LocCDType } from 'api';
import { appLocations } from 'common';
import { TabsComponent } from 'ui-elements/tabs';
import { NgHeadingComponent } from 'ui-elements/ng-heading';
import { ChipComponent } from 'ui-elements/chip';
import { mapLocationOptions, ITabs } from 'common';
import {
  CalendarEvent,
  CalendarEventTab,
  CalendarEventType,
  CalendarLocations,
  CalendarYear,
} from '../../interfaces/calendar.interfaces';

import { SelectData, ssSelectImports } from 'ui-elements/select';

@Component({
  selector: 'ss-stx-shared-calendar-controls',
  templateUrl: './calendar-controls.component.html',
  styleUrls: ['./calendar-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChipComponent, NgHeadingComponent, ssSelectImports, TabsComponent],
})
export class CalendarControlsComponent {
  @Input() locations: CalendarLocations[] = [];
  @Input() years: CalendarYear[] | null = [];
  @Input() events: CalendarEvent[] = [];
  @Input() eventYear: number | undefined = undefined;
  @Input() eventTypes: CalendarEventTab[] = [
    {
      label: 'ALL',
      disabled: false,
      open: true,
    },
  ];

  @Input() empCompTypes?: SelectData<string>[];
  @Input() employeeCompTypeValue?: string;
  readonly locationSelected = input<LocCDType | null>();
  @Input() transferEvent?: boolean;
  @Output() locationChange = new EventEmitter<LocCDType>();
  @Output() yearChange = new EventEmitter<number>();
  @Output() eventTypeChange = new EventEmitter<CalendarEventType>();
  @Output() eventCompTypeChange = new EventEmitter<string>();

  locationOptions = computed(() => {
    return this.locationSelected()
      ? mapLocationOptions(this.locationSelected()!, false)
      : undefined;
  });

  get yearsTabOptions(): ITabs[] | undefined {
    return this.years?.map(
      (year) =>
        ({
          open: year.selected,
          label: year.year.toString(),
          disabled: year.disabled,
        }) as ITabs
    );
  }

  //#region Public Methods
  handleLocationChange(event: LocCDType) {
    this.locationChange.emit(
      appLocations.find((loc) => loc.name === event)!.code
    );
  }

  handleYearChange(event: string) {
    this.yearChange.emit(Number(event));
  }

  handleEvenTypeChange(event: CalendarEventType) {
    this.eventTypeChange.emit(event);
  }
  handleCompTypeChange(event: SelectData<string>[]) {
    this.eventCompTypeChange.emit(event[0].value || undefined);
  }
  //#endregion
}
